import React from 'react'

import {createSvgIcon} from './utils'

export default createSvgIcon(
  <React.Fragment>
    <path
      opacity="0.4"
      d="M13.285 12.5016V14.2153H0.856445L2.54813 6.83015C2.70674 6.13772 3.32276 5.64674 4.03313 5.64658L13.285 5.64453V8.2159H17.8261C18.764 8.2159 19.6192 8.75293 20.0265 9.59779L21.4266 12.5016H13.285Z"
      fill="#21201F"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.7696 6.98025C10.9471 6.19888 11.6422 5.64476 12.4435 5.64482C12.853 5.64485 13.2482 5.64471 13.6505 5.64453C14.6323 5.6441 15.4283 6.43991 15.4283 7.42175V8.21373H12.5051L12.5048 8.21527H12.8569V12.5009H21.4289C22.849 12.5009 24.0003 13.6522 24.0003 15.0723V17.6436C24.0002 19.0637 22.849 20.2151 21.4289 20.2151C20.3093 20.2151 19.3568 19.4996 19.0038 18.5009H16.9965C16.6434 19.4996 15.691 20.2151 14.5714 20.2151C13.4519 20.2151 12.4994 19.4996 12.1464 18.5009H5.85391C5.50087 19.4996 4.54841 20.2151 3.42885 20.2151C2.00874 20.2151 0.857497 19.0639 0.857422 17.6438V14.2149H10.6939V14.2137H9.12695L10.7696 6.98025ZM3.42885 18.5617C3.9359 18.5617 4.34695 18.1507 4.34695 17.6436C4.34695 17.1366 3.9359 16.7255 3.42885 16.7255C2.9218 16.7255 2.51076 17.1366 2.51076 17.6436C2.51076 18.1507 2.9218 18.5617 3.42885 18.5617ZM15.4895 17.6436C15.4895 18.1507 15.0785 18.5617 14.5714 18.5617C14.0644 18.5617 13.6533 18.1507 13.6533 17.6436C13.6533 17.1366 14.0644 16.7255 14.5714 16.7255C15.0785 16.7255 15.4895 17.1366 15.4895 17.6436Z"
      fill="#21201F"
    />
  </React.Fragment>,
  'CargoIcon',
)
